<template>
  <v-autocomplete
    v-model="computedValue"
    :disabled="
      (blacklistCheckFailed && messageType === 'sms_text') || isLoading
    "
    :items="filteredLines"
    :label="dynamicLabel"
    :placeholder="dynamicPlaceholder"
    :loading="isLoading"
    :rules="[rules.line]"
    dense
    outlined
    clearable
    :prepend-inner-icon="
      messageType === 'sms_text'
        ? 'sms'
        : messageType === 'sms_voice'
        ? 'voicemail'
        : 'message'
    "
    @change="handleChange"
  >
    <template v-slot:item="{ item }">
      <span v-html="item.text"></span>
    </template>

    <template v-slot:selection="{ item }">
      <span v-html="item.text"></span>
    </template>

    <template v-slot:no-data>
      <span class="mx-2">
        {{ isLoading ? "در حال بارگذاری..." : "هیچ گزینه‌ای یافت نشد" }}
      </span>
    </template>
  </v-autocomplete>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "sendOperatorPicker",

  props: {
    value: [String, Object, Number],
    messageType: {
      type: String,
      default: "sms_text",
      validator: (val) =>
        ["sms_text", "sms_voice", "whatsapp", "bale", "email"].includes(val),
    },
    label: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      defaultNumber: null,
      rules: {
        line: (v) => !!v || "لطفاً یک گزینه انتخاب کنید",
      },
    };
  },

  computed: {
    ...mapGetters("smsNumbersIndex", ["lines", "loading"]), // sms_text
    // ...mapGetters("voiceOperators", ["voiceLines", "voiceLoading"]), // sms_voice
    // ...mapGetters("socialOperators", ["socialLines", "socialLoading"]), // whatsapp,bale
    ...mapGetters("locals", [
      "blacklistCheckFailed",
      "blacklistAlt",
      "blacklistAlternateSends",
    ]),

    dynamicLabel() {
      if (this.label) return this.label;

      switch (this.messageType) {
        case "sms_voice":
          return "اپراتور پیام صوتی";
        case "whatsapp":
          return "نام کاربری واتساپ";
        case "bale":
          return "نام کاربری بله";
        default:
          return "سرشماره پیامک";
      }
    },
    dynamicPlaceholder() {
      switch (this.messageType) {
        case "sms_voice":
          return "انتخاب اپراتور صوتی";
        case "whatsapp":
          return "انتخاب نام کاربری واتساپ";
        case "bale":
          return "انتخاب نام کاربری بله";
        default:
          return "انتخاب سرشماره";
      }
    },

    filteredLines() {
      switch (this.messageType) {
        // case "sms_voice":
        //   return this.voiceLines;
        // case "whatsapp":
        //   return this.socialLines;
        // case "bale":
        //   return this.socialLines;

        default:
          return this.lines;
      }
    },

    isLoading() {
      switch (this.messageType) {
        // case "sms_voice":
        //   return this.voiceLoading;
        // case "whatsapp":
        //   return this.socialLoading;
        // case "bale":
        //   return this.socialLoading;
        default:
          return this.loading;
      }
    },

    computedValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },

  watch: {
    blacklistCheckFailed(val) {
      if (val) {
        this.defaultNumber = this.computedValue;
        this.computedValue = this.blacklistAlternateSends.find(
          (item) => item.value === this.blacklistAlt,
        ).number;
      } else {
        this.computedValue = this.defaultNumber;
      }
    },
    blacklistAlt(val) {
      this.computedValue = this.blacklistAlternateSends.find(
        (item) => item.value === val,
      ).number;
    },
    lines: {
      immediate: true,
      deep: true,
      handler(val) {
        if (
          this.messageType === "sms_text" &&
          !this.computedValue &&
          val &&
          val.length > 0
        ) {
          this.computedValue = val[0]?.value;
        }
      },
    },
    messageType: {
      immediate: true,
      handler(newType) {
        this.loadOperators(newType);
      },
    },
  },

  methods: {
    async loadOperators(type) {
      if (type === "sms_text" && this.lines.length > 0) return;
      // if (type === "sms_voice" && this.voiceLines.length > 0) return;
      // if (type === "whatsapp" && this.socialLines.length > 0) return;
      // if (type === "bale" && this.socialLines.length > 0) return;

      let actionName = "";

      switch (type) {
        case "sms_text":
          actionName = "smsNumbersIndex/fetchIndexData";
          break;
        // case "sms_voice":
        //   actionName = "voiceOperators/fetchVoiceOperators";
        //   break;
        // case "whatsapp":
        //   actionName = "socialOperators/fetchSocialOperators";
        //   break;
        // case "bale":
        //   actionName = "socialOperators/fetchSocialOperators";
        //   break;

        default:
          return;
      }

      try {
        await this.$store.dispatch(actionName);
      } catch (err) {
        console.error(`خطا در بارگذاری ${type}:`, err);
        this.$toast?.error(
          `نمی‌توان لیست ${this.dynamicLabel} را بارگذاری کرد`,
        );
      }

      const currentList = this.filteredLines;
      if (!this.computedValue && currentList.length > 0) {
        this.computedValue = currentList[0].value;
      }
    },

    handleChange(val) {
      this.$emit("change", val);

      if (this.messageType === "sms_text" && val === "123450") {
        this.$modal?.info(
          "توجه فرمایید",
          'در زمان ارسال پیامک با سرشماره "ارسال خبری" حداقل تعداد بایستی ۱۰۰۰ عدد باشد.',
        );
      }
    },
  },

  mounted() {
    this.loadOperators(this.messageType);
  },
};
</script>

<style scoped></style>
